import "core-js/modules/es.array.find-index";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmToolNew, pickerOption, gmToolNewPage } from "@/mixins/index";
import addGift from "./components/addGift.vue";
import { szgmGiftList, szgmDelGift } from "@/api/gmToolNew/gmToolNew";
import viewArticles from "../email/components/viewArticles";
export default {
  name: "gmToolNewgift",
  components: {
    addGift: addGift,
    viewArticles: viewArticles
  },
  mixins: [gmToolNew, pickerOption, gmToolNewPage],
  data: function data() {
    return {
      reqLoading: false,
      paramsData: {
        page: 1,
        gift_id: '',
        name: '',
        desc: '',
        refresh: '',
        expire: '',
        cost: ''
      },
      tableData: [],
      // 表格数据
      total: 0,
      tableCopyTableList: [],
      // 表格copy数据b
      stateArr: [{
        label: '发送成功',
        value: 1
      }, {
        label: '未发送',
        value: 2
      }, {
        label: '发送失败',
        value: 3
      }],
      refreshType: [{
        label: '全部',
        value: ''
      }, {
        label: '不刷新',
        value: 0
      }, {
        label: '日刷新',
        value: 1
      }, {
        label: '周刷新',
        value: 2
      }, {
        label: '月刷新',
        value: 3
      }]
    };
  },
  created: function created() {},
  beforeCreate: function beforeCreate() {
    var that = this;
  },
  filters: {
    RefreshType: function RefreshType(value) {
      var refreshType = [{
        label: '不刷新',
        value: 0
      }, {
        label: '日刷新',
        value: 1
      }, {
        label: '周刷新',
        value: 2
      }, {
        label: '月刷新',
        value: 3
      }];
      return refreshType[refreshType.findIndex(function (item) {
        return item.value == value;
      })].label;
    }
  },
  methods: {
    expireChange: function expireChange(e) {
      this.paramsData.expire = e ? e + ' 00:00:00' : ''; // this.paramsData.expire = e / 1000
    },
    getList: function getList(e) {
      var _this = this;

      if (!this.paramsData.server_id) {
        this.$message.error('请选择服务器');
        return;
      }

      this.paramsData.page = e;
      this.reqLoading = true;
      szgmGiftList(_objectSpread({}, this.paramsData)).then(function (res) {
        if (res.code == 200) {
          if (!res.data.data.length && _this.paramsData.page > 1) {
            _this.getList(_this.paramsData.page - 1);
          } else {
            _this.tableData = res.data.data;
            _this.total = res.data.total;
          }
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    // 删除配置
    deleHandle: function deleHandle(id) {
      var _this2 = this;

      this.$confirm("此操作将删除该礼包, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                szgmDelGift({
                  gift_id: id,
                  server_id: _this2.paramsData.server_id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.getList(_this2.paramsData.page);

                    _this2.$message({
                      type: "success",
                      message: '删除成功'
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};